var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGovernment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#162B33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#162B33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9804 70.67V66.34H24.0204V70.67H19.6904V75H80.3104V70.67H75.9804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0804 10.62L20.4804 28.5C19.0004 29.42 19.6604 31.7 21.4004 31.7H78.6004C80.3404 31.7 80.9904 29.42 79.5204 28.5L50.9204 10.62C50.3604 10.27 49.6504 10.27 49.0804 10.62Z",
    fill: "#E2F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6005 31.95H21.4005C20.4905 31.95 19.7405 31.39 19.4905 30.51C19.2405 29.64 19.5705 28.76 20.3405 28.28L48.9405 10.4C49.5805 9.99998 50.4005 9.99998 51.0405 10.4L79.6405 28.28C80.4105 28.76 80.7405 29.63 80.4905 30.51C80.2405 31.38 79.4905 31.95 78.5805 31.95H78.6005ZM50.0005 10.61C49.7305 10.61 49.4505 10.68 49.2105 10.83L20.6105 28.71C19.9105 29.15 19.8305 29.88 19.9705 30.38C20.1105 30.88 20.5705 31.45 21.3905 31.45H78.5905C79.4105 31.45 79.8705 30.87 80.0105 30.38C80.1505 29.88 80.0705 29.15 79.3705 28.71L50.7705 10.83C50.5305 10.68 50.2605 10.61 49.9805 10.61H50.0005Z",
    fill: "#4782FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6807 31.7H28.3507V62.0099H26.1807V66.3399H34.8407V62.0099H32.6807V31.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6611 31.7H54.3311V62.0099H52.1611V66.3399H60.8311V62.0099H58.6611V31.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6709 31.7H41.3409V62.0099H39.1709V66.3399H47.8309V62.0099H45.6709V31.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6511 62.0099V31.7H67.3211V62.0099H65.1611V66.3399H73.8211V62.0099H71.6511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0009 27.37C52.3923 27.37 54.3309 25.4314 54.3309 23.04C54.3309 20.6486 52.3923 18.71 50.0009 18.71C47.6095 18.71 45.6709 20.6486 45.6709 23.04C45.6709 25.4314 47.6095 27.37 50.0009 27.37Z",
    fill: "#4782FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernment);
export default __webpack_public_path__ + "static/media/government.2181f494d70fd5b381b1db53bb99a88e.svg";
export { ForwardRef as ReactComponent };